import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.expensesub;
import App from "./App/App.js";

export default {
  getList(params) {
    let options = { cid: App.Session.getCompanyID() };
    options = Object.assign(options, params);
    if (!Object.prototype.hasOwnProperty.call(options, "active")) {
      options.active = 1;
    }
    const attributes = ["cid", "name", "category", "active", "field"];
    const urlParams = App.Out.getParams(options, attributes);
  
    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/expensesubcat/list" + urlParams
    };
  },

  getAllList(params) {
    let options = { cid: App.Session.getCompanyID() };
    options = Object.assign(options, params);
    const attributes = ["cid", "name", "category", "active", "field"];
    const urlParams = App.Out.getParams(options, attributes);
    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/expensesubcat/list" + urlParams
    };
  },

  getDetail(id) {
    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/expensesubcat/" + id
    }
  },

  postCategory(data) {
    data['CompanyID'] = App.Session.getCompanyID();
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/expensesubcat",
      data: data
    }
  },

  putCategory(data) {
    return {
      method: App.Enum.Axios.Method.Put,
      url: apiEndpoint + "/api/v1/expensesubcat",
      data: data
    }
  }
}